export enum FieldNotifications {
    LeaveNearingBank1Exhaustion = -1,
    ReadyToClose = -2,
    LeaveBank1HoursExhausted = -3,
    LeaveNearingBank2Exhaustion = -4,
    LeaveBank2HoursExhausted = -5,
    LeaveNearingBank3Exhaustion = -6,
    LeaveBank3HoursExhausted = -7,
    ImportVerification = -8,
    LeaveNearingBank4Exhaustion = -9,
    LeaveBank4HoursExhausted = -10,
    LeaveNearingBank5Exhaustion = -11,
    LeaveBank5HoursExhausted = -12,
}